<label class="control-label" [innerHTML]="htmlTransform(fieldData.metadata.label)"></label>

<div>
    <iframe [src]='safeUrl' sandbox="allow-forms allow-modals allow-popups allow-scripts allow-same-origin"></iframe> <!-- CodeQL [SM02170] allow-scripts is required, as the page loaded into the frame runs some JavaScript to deal with user interaction.allow-same-origin is necessary, as paymente central cookies would otherwise be inaccessible, and the user couldn't log in to post the form. This does not post any security threat.-->
</div>
